import { render, staticRenderFns } from "./login-CA.vue?vue&type=template&id=cd8b91f6&scoped=true&"
import script from "./login-CA.vue?vue&type=script&lang=js&"
export * from "./login-CA.vue?vue&type=script&lang=js&"
import style0 from "./login-CA.vue?vue&type=style&index=0&id=cd8b91f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8b91f6",
  null
  
)

export default component.exports